<div class="md-input-container">
    <mat-form-field class="mat-form-withtooltip" style="width: 90%;">
        <mat-label *ngIf="isDisabled">{{label}} *</mat-label>
        <mat-label *ngIf="!isDisabled">{{label}}</mat-label>
        <mat-select [(ngModel)]="value" 
        [disabled]="isDisabled"
                    [required]="required"
        [compareWith]="objectComparison"
                    #currency_id="ngModel"
        name="currency_id" (openedChange)="onOpen($event)"
        [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''"
        >
            <mat-option *ngIf="items === null || !items.length" class="minh88" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}</mat-option>
        </mat-select>
        <mat-error class="md-errormsg" *ngIf="!currency_id.valid && currency_id.touched && required">Required</mat-error>
    </mat-form-field>
    <mat-icon *ngIf="ShowHelp" [matTooltip]="helptext" matTooltipPosition="above">
        help
    </mat-icon>
</div>
<mat-error class="sm-errormsg" *ngIf="!currency_id.valid && currency_id.touched && required">Required</mat-error>
